import React from 'react'
import { UseFormRegister } from 'react-hook-form'
import { ComboboxGroupItem, ComboboxItem } from '@node-space/ui-components'
import { AddCustomerFormErrors, AddCustomerPayload, CustomerEntityType } from 'types/customers'
import { BusinessCustomerFields } from './CustomerEntityType/Business'
import { IndividualCustomerFields } from './CustomerEntityType/Individual'

interface CustomerEntityFormProps {
  // General
  activeTab: CustomerEntityType
  countries?: ComboboxItem[]
  isCountriesLoading?: boolean
  addressLine1?: string
  addressLine2?: string
  city?: string
  postalCode?: string
  countryCode?: string
  stateCode?: string
  nationality?: string
  errors?: AddCustomerFormErrors
  register?: UseFormRegister<AddCustomerPayload>
  setValue?: (name: string, value: string) => void
  // Business customer
  businessName?: string
  businessDescription?: string
  registrationNumber?: string
  businessTaxResidency?: string
  businessMonthlyVolume?: string
  monthlyVolumesOptions?: ComboboxItem[]
  isFetchingMonthlyVolumes?: boolean
  industryOptions?: ComboboxGroupItem[]
  isFetchingIndustries?: boolean
  industry?: string
  states?: ComboboxItem[]
  isFetchingStates?: boolean
  email?: string
  phoneNumber?: string
  // Individual customer
  firstName?: string
  lastName?: string
  dateOfBirth?: string
  personalIdNumber: string
  nationalityName: string
  individualCustomerDescription?: string
}

export const CustomerEntityForm = ({
  // General
  activeTab,
  countries,
  isCountriesLoading,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  countryCode,
  stateCode,
  nationality,
  errors,
  register,
  setValue,
  // Business customer
  businessName,
  businessDescription,
  registrationNumber,
  businessTaxResidency,
  businessMonthlyVolume,
  monthlyVolumesOptions,
  isFetchingMonthlyVolumes,
  industryOptions,
  isFetchingIndustries,
  industry,
  states,
  isFetchingStates,
  // Individual customer
  firstName,
  lastName,
  dateOfBirth,
  personalIdNumber,
  individualCustomerDescription,
}: CustomerEntityFormProps) => {
  switch (activeTab) {
    case CustomerEntityType.COMPANY:
      return (
        <BusinessCustomerFields
          businessName={businessName}
          businessDescription={businessDescription}
          registrationNumber={registrationNumber}
          isCountriesLoading={isCountriesLoading}
          countries={countries}
          businessTaxResidency={businessTaxResidency}
          businessMonthlyVolume={businessMonthlyVolume}
          monthlyVolumesOptions={monthlyVolumesOptions}
          isFetchingMonthlyVolumes={isFetchingMonthlyVolumes}
          industryOptions={industryOptions}
          isFetchingIndustries={isFetchingIndustries}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          city={city}
          postalCode={postalCode}
          countryCode={countryCode}
          industry={industry}
          firstName={firstName}
          lastName={lastName}
          dateOfBirth={dateOfBirth}
          nationality={nationality}
          errors={errors}
          register={register}
          setValue={setValue}
          states={states}
          stateCode={stateCode}
          isFetchingStates={isFetchingStates}
        />
      )
    case CustomerEntityType.INDIVIDUAL:
      return (
        <IndividualCustomerFields
          firstName={firstName}
          lastName={lastName}
          dateOfBirth={dateOfBirth}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          city={city}
          postalCode={postalCode}
          countryCode={countryCode}
          stateCode={stateCode}
          countries={countries}
          isCountriesLoading={isCountriesLoading}
          states={states}
          isFetchingStates={isFetchingStates}
          errors={errors}
          personalIdNumber={personalIdNumber}
          individualCustomerDescription={individualCustomerDescription}
          register={register}
          setValue={setValue}
        />
      )
    default:
      return null
  }
}
